import { Footer2022, Intro2022 } from '../components';
import { use2022Page } from '../shared';

const SPLA2022ZhIndex = () => {
  use2022Page({ cate: 'index', lang: 'zh', title: '2022智慧生活夥伴大獎' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="zh" />
      <section id="LeadIn">
        <div className="wave_bg"><img src="/2022/images/wave_bg.png" alt="" /></div>
        <div className="LeadIn_info">
          <div className="LeadIn_Title">「2022智慧生活夥伴大獎」</div>
          <div className="LeadIn_Content">
            <p>在新經濟之下，零售業、醫療業、消費轉變和人類行為，在過去幾年間急速地向數碼化轉型。通過連接科技以優化成可持續城市不僅是不可阻擋的全球現象，也是在新常態下以綠色方式開拓新道路的唯一解決方案。</p>
            <p>「可持續發展下元智慧生活」希望強調智慧城市不僅僅是解決營運問題的智能工具，它也是使城市和人類住區具有包容性、安全性、韌性和可持續性的目標。元宇宙概念正在成為智慧生活的核心，它將通過連接虛擬世界和現實世界來構建一個高效率的城市。元宇宙的發展意味著未來智慧生活創新的無限突破，同時打造屬於我們獨一無二的明日之城。</p>
            <p>經濟通的「2022智慧生活夥伴大獎」已經是連續第三年與數碼港共同合辦，目的是表揚、推廣和支持致力於推動香港成為智慧城市、提升社會競爭力和提高公眾對數字化意識的優秀企業或組織。獎項不同的類別望能帶出智慧生活中的創新科技在日常生活各個領域範疇的重要性和好處。</p>
          </div>
          <div className="LeadIn_Content_Video">
            <a href="https://youtu.be/atCC8QdiTaw"><img src="https://img.youtube.com/vi/atCC8QdiTaw/maxresdefault.jpg" alt="" /></a>
            <p>2022智慧生活夥伴大獎活動花絮</p>
          </div>
        </div>
      </section>
      <section id="AwardCategory"><div className="AwardCategory_info"><div className="AwardCategory_Title">獎項類別</div><div className="AwardCategory_TitleLine"><div className="AwardCategory_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div><div className="AwardCategory_BubbleTable">{['藝術與文化','教育技術','樂齡科技','健康科技','行銷科技 (智能零售 / 電子商務)','元宇宙','房地產建築科技','中小型企業（旅遊 / 人力資源 / 行政）','智能建設 / 環境科技 / 綠色科技','智慧政府','智慧出行','智慧勞動管理','智慧衣服 / 物聯網 / 機械人技術'].map((t,i)=><a key={t} href={`/2022/zh/awards.php?cat_id=${i+1}`}><div className="AwardCategory_Bubble"><p>{t}</p></div></a>)}</div></div></section>
      <section id="ImportantDate">
        <div className="ImportantDate_info">
          <div className="ImportantDate_Title">活動詳情</div>
          <div className="ImportantDate_DateTable">
            <div className="ImportantDate_Date"><div className="ImportantDate_Date_Wrapper"><div className="ImportantDate_Date_WrapperA"><div className="ImportantDate_Day">3</div></div><div className="ImportantDate_Date_WrapperB"><div className="ImportantDate_Month">Feb</div><div className="ImportantDate_Year">2023</div></div></div></div>
            <div className="ImportantDate_Line"><div className="ImportantDate_LineDot"><img src="/2022/images/linedot.png" alt="" /></div></div>
            <div className="ImportantDate_Date"><div className="ImportantDate_Date_Wrapper"><div className="ImportantDate_Date_WrapperA"><div className="ImportantDate_Day">27</div></div><div className="ImportantDate_Date_WrapperB"><div className="ImportantDate_Month">Feb</div><div className="ImportantDate_Year">2023</div></div></div></div>
            <div className="ImportantDate_Line"><div className="ImportantDate_LineDot"><img src="/2022/images/linedot.png" alt="" /></div></div>
            <div className="ImportantDate_Date"><div className="ImportantDate_Date_Wrapper"><div className="ImportantDate_Date_WrapperA"><div className="ImportantDate_Day">27</div></div><div className="ImportantDate_Date_WrapperB"><div className="ImportantDate_Month">Feb</div><div className="ImportantDate_Year">2023</div></div></div></div>
          </div>
          <div className="ImportantDate_DetailTable">
            <div className="ImportantDate_Detail"><div className="ImportantDate_Description">截止報名</div></div>
            <div className="ImportantDate_Detail"><div className="ImportantDate_Description">得獎名單公布</div></div>
            <div className="ImportantDate_Detail"><div className="ImportantDate_Description">頒獎典禮</div></div>
          </div>
        </div>
      </section>
      <Footer2022 lang="zh" />
    </div>
  );
};

export default SPLA2022ZhIndex;

